'use strict';

var tslib = require('tslib');
var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var ThirdPartyScripts = function (_a) {
    var scripts = _a.scripts, Head = _a.Head;
    return (React__namespace.createElement(React__namespace.Fragment, null, scripts === null || scripts === void 0 ? void 0 : scripts.filter(function (script) { return script.conditions(); }).map(function (_a) {
        var id = _a.id, src = _a.src; _a.conditions; var scriptSnippet = _a.scriptSnippet, initializeArea = _a.initializeArea, _b = _a.async, async = _b === void 0 ? true : _b, rest = tslib.__rest(_a, ["id", "src", "conditions", "scriptSnippet", "initializeArea", "async"]);
        var scriptElement = (React__namespace.createElement("script", tslib.__assign({ id: id, key: id, src: src }, (scriptSnippet ? { dangerouslySetInnerHTML: { __html: scriptSnippet } } : {}), (async ? { async: true } : {}), rest)));
        return initializeArea === 'top' && Head ? React__namespace.createElement(Head, { key: id }, scriptElement) : scriptElement;
    })));
};

module.exports = ThirdPartyScripts;
//# sourceMappingURL=ThirdPartyScripts.js.map
